// extracted by mini-css-extract-plugin
module.exports = {"itemflows":"ItemFlowsModal_itemflows__1hCCD"};